import * as XLSX from "xlsx";

export class XlsxAdapter {
    decodeRange(str) {
        return XLSX.utils.decode_range(str);
    }

    sheetToCsv(worksheet, options) {
        return XLSX.utils.sheet_to_csv(worksheet, options);
    }

    sheetToJson(worksheet, options) {
        return XLSX.utils.sheet_to_json(worksheet, options);
    }

    JsonToSheet(json, options) {
        return XLSX.utils.json_to_sheet(json, options);
    }

    read(data, options) {
        return XLSX.read(data, options);
    }

    writeFile(wb, filename) {
        return XLSX.writeFile(wb, filename);
    }

    bookNew() {
        return XLSX.utils.book_new();
    }

    bookAppendSheet(wb, ws, sheetName) {
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
    }

    encodeCell(data) {
        return XLSX.utils.encode_cell(data);
    }
}
